import { AttachmentModel } from '@fc-vehicles/service/attachment-model';
import { VehicleManufacture } from '@fc-vehicles/models/vehicle.manufacture';
import { StatusSet, VehicleStateType, VehicleType } from '@fc-core/models';
import { VehicleDriverStatus } from './vehicle-driver.model';
import { VehiclePowerSource } from '@fc-core/models/vehicle/power-source';

export enum VehicleStatus {
  active = 'active',
  waiting_for_data = 'pending',
  unlinked = 'unlinked',
}

export type VehicleVisibility = 'visible' | 'hidden' | 'archive';

export interface Vehicle {
  id: number;
  visibility?: VehicleVisibility;
  status?: VehicleStatus;
  identifier: string;
  model: string;
  year: number | null;
  vin?: string | null;
  vinOverride?: string | null;
  realOdometer?: number | null;
  realEngineHours?: number | null;
  detectedVin?: string | null;
  photo?: AttachmentModel | null;
  hardware: number | null;
  harness: number | null;
  groups: number[];
  created: string;
  modified?: string;
  type: number;
  statesUrl?: string;
  powerSource?: VehiclePowerSource;
  specifications: { [key: string]: any };
  manufacturer: VehicleManufacture | null;
  camera?: number | null;
  typeObj?: VehicleType;
  pendingMaintenanceCount?: number;
  pendingDtcCount?: number;
  lastState?: LastVehicleState | null;
  lastReading?: LastVehicleReading | null;
  mil?: number;
  operators?: VehicleOperator[];
  loadingFields?: boolean;
  nonTracker?: boolean;
  currentLocation?: {
    id: number;
    name: string;
    type: number;
  } | null;
  hash?: string;
  active?: boolean;
  setstatus?: StatusSet | null;
  ngcamera?: number | null;
  voltage?: number;
  operator?: VehicleDriverStatus;
  hasQrCode?: boolean;
}

export interface VehicleOperator {
  id: number;
  isArchived: boolean;
  isDisabled: boolean;
  employee: {
    id: string;
    firstName: string;
    lastName: string;
    avatar: string | AttachmentModel | null;
    color?: string | null;
  };
}

export interface LastVehicleState {
  duration: { lower: string; upper: string | null };
  type: VehicleStateType;
}

export interface LastVehicleReading {
  datetime: Date;
  heading: number;
  point: { lat: number; lng: number };
  signalStrength: number;
  batteryPercent?: number | null;
  speed: number;
}
